import { LoadingButton } from 'src/components/buttons/LoadingButton';
import { useDialog } from './useDialog';
import { useCallback } from 'react';
import Stack from '@mui/material/Stack';

export type OpenParams = {
  title: string;
  description: string;
  confirmationFunction: () => Promise<void>;
};

export const useConfirmDialog = (id: string) => {
  const { open: openDialog, close } = useDialog(id);

  const open = useCallback(
    ({ title, description, confirmFunction }) =>
      openDialog({
        title,
        description,
        children: (
          <Stack direction="row" width={'100%'} height={60} mt={2} spacing={2}>
            <LoadingButton
              variant="outlined"
              onClick={confirmFunction}
              color="success"
              fullWidth
            >
              Confirm
            </LoadingButton>

            <LoadingButton
              variant="outlined"
              // THIS ISNT ASYNC
              onClick={async () => close()}
              color="error"
              fullWidth
            >
              Go Back
            </LoadingButton>
          </Stack>
        ),
      }),
    [close, openDialog],
  );

  return { open, close };
};
